import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";

import "moment/locale/pt-br";
import "moment/locale/es";

type Props = {
  children: React.ReactNode;
};

export default function LanguageProvider({ children }: Props) {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Se estiver vindo "pt-BR", "en-US", "es", normalize para "pt-br", "en", etc
    const lang = i18n.language.toLowerCase().replace("_", "-");
    moment.locale(lang);
  }, [i18n.language]);

  return <>{children}</>;
}
